import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ParsConstants {
  public DELAYED = 5;
  public DID_NOT_DEPLOY = 12;
  public NOT_SET_RMS = 50;
  public NOT_DEMOBILIZED = 51;
  public NOT_ASSIGNED_ROLE = 52;

  public ONSITE: number = 1;
  public ENROUTE: number = 2;
  public STAGED: number = 3;
  public BILLETING: number = 4;
  public DEMOBILIZING: number = 5;
  public DEMOBILIZED: number = 6;
  public ARRIVED: number = 7;

  public RESERVED: number = 996;
  public BACKFILL: number = 999;

  public TEAM_SELECTION: number = 998;

  public AGENCY_NDMS: number = 1;
  public CONTROLLER_EMG: number = 1;
  public NONE_NOTAPPLICABLE: number = 0;
  public HOME_ADDRESS: number = 1;
  public HOME_PHONE: number = 5;
}
